import { useEffect } from 'react';

const BASE_TITLE = 'TSCORP HR';

export function useDocumentTitle(pageTitle?: string) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} - ${BASE_TITLE}` : `${BASE_TITLE} Intelligence`;
    return () => {
      document.title = `${BASE_TITLE} Intelligence`;
    };
  }, [pageTitle]);
}
